import React from "react";
import { Container, Row ,Col} from "react-bootstrap";
import MailChimFrom from "./MailChimFrom"
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
export default function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailChimFrom/>
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className='text-center text-sm-end'>
            <div className="social-icon">
                <a href="#"><img src={navIcon1} alt="icon" /></a>
                <a href="#"><img src={navIcon2} alt="icon" /></a>
                <a href="#"><img src={navIcon3} alt="icon" /></a>
            </div>
            <p>CopyRight 2022. All Right Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
